









































































































































import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { Action } from 'vuex-class';
import { ChangePassword } from '@/interfaces/ChangePassword';

interface RefsInterface {
    ruleForm: ElForm;
}

@Component({
    name: 'ResetPassword',
})
export default class ResetPassword extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;

    protected ruleForm = {
        password: '',
        passwordRepeat: '',
    };

    protected rules = {
        password: [{ validator: this.validatePass, trigger: 'blur' }],
        passwordRepeat: [{ validator: this.validatePass2, trigger: 'blur' }],
    };
    protected termsOfUseLink =
        process.env.VUE_APP_MARKABLES_PRESENTATION_BASE_URL +
        '/legal/#terms_of_use';
    @Action('user/changePassword') private changePassword!: (
        payload: ChangePassword,
    ) => Promise<unknown>;

    private state = 'pending';
    private isSettingPassword = false;

    protected submitForm(formName: keyof RefsInterface) {
        const form = this.$refs[formName] as ElForm;
        form.validate((valid: boolean) => {
            if (valid) {
                this.attemptChangePassword()
                    .then(() => {
                        this.state = 'success';
                    })
                    .catch((e: Error) => {
                        this.state = 'error';
                    });
            } else {
                return false;
            }
        });
    }

    protected async created() {
        if (!this.$route.params.token) {
            this.$router.push({ name: 'Login' });
            return;
        }
        if (this.$route.query.setPassword) {
            this.isSettingPassword = true;
        }
    }

    protected attemptChangePassword() {
        return this.changePassword({
            password: this.ruleForm.password,
            passwordRepeat: this.ruleForm.passwordRepeat,
            token: this.$route.params.token,
        });
    }

    protected toLogin() {
        this.$router.push({ name: 'Login' });
    }

    private validatePass(
        rule: unknown,
        value: string,
        callback: (error?: Error) => {},
    ) {
        if (value === '') {
            callback(new Error('Please input your new password'));
        } else if (value.length < 6) {
            callback(new Error('Password must have 6 characters or more'));
        } else {
            if (this.ruleForm.passwordRepeat !== '') {
                this.$refs.ruleForm.validateField('passwordRepeat', () => {
                    return undefined;
                });
            }
            callback();
        }
    }

    private validatePass2(
        rule: unknown,
        value: string,
        callback: (error?: Error) => {},
    ) {
        if (value === '') {
            callback(new Error('Please repeat your new password'));
        } else if (value !== this.ruleForm.password) {
            callback(new Error("Password don't match!"));
        } else {
            callback();
        }
    }
}
